import React, { useContext, useRef } from "react";
import Button from "@amzn/meridian/button";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import { chainWalk, getFormattedTime } from "../../util/Util";
import Text from "@amzn/meridian/text";
import { SettingsContext } from "./SettingsContext";
import {
  getECCFLaborAvailabilityS3DownloadUrl,
  getECCFLaborAvailabilityS3UploadUrl,
} from "./SettingsNetworkAPI";
import { FileTransferUtil } from "./FileTransferUtil";

const AmzlRosterManagement = (props) => {
  const { viewModel, dispatch } = useContext(SettingsContext);
  const rosterFileInputRef = useRef(null);
  const isUserAuthorisedForSettingsEdit = true;

  const rosterLastUpdatedBy = chainWalk(
    () => viewModel.settingsData.roster.lastUpdatedBy,
    null,
  );
  const rosterLastUpdatedAt = chainWalk(
    () => viewModel.settingsData.roster.lastUpdatedAt,
    null,
  );

  const scheduleLastUpdatedBy = chainWalk(
    () => viewModel.settingsData.schedule.lastUpdatedBy,
    null,
  );
  const scheduleLastUpdatedAt = chainWalk(
    () => viewModel.settingsData.schedule.lastUpdatedAt,
    null,
  );

  const {
    isValidFile: isValidRosterFile,
    alertMessage: rosterAlertMessage,
    error: rosterError,
    handleDownload: handleRosterDownload,
    handleFileChange: handleRosterFileChange,
  } = FileTransferUtil({
    getDownloadUrl: () => getECCFLaborAvailabilityS3DownloadUrl("roster"),
    getUploadUrl: () => getECCFLaborAvailabilityS3UploadUrl("roster"),
    fileName: "Roster",
    fileType: "csv",
    onUploadSuccess: (updatedData) => {
      dispatch({
        type: "UPDATE_ROSTER",
        data: {
          roster: updatedData,
        },
      });
    },
    errorMessages: {
      fileNotExist: "Roster file does not exist. Please upload a valid one.",
    },
  });

  const {
    isValidFile: isValidScheduleFile,
    alertMessage: scheduleAlertMessage,
    error: scheduleError,
    handleDownload: handleScheduleDownload,
    handleFileChange: handleScheduleFileChange,
  } = FileTransferUtil({
    getDownloadUrl: () => getECCFLaborAvailabilityS3DownloadUrl("schedule"),
    getUploadUrl: () => getECCFLaborAvailabilityS3UploadUrl("schedule"),
    fileName: "Schedule",
    fileType: "csv",
    onUploadSuccess: (updatedData) => {
      dispatch({
        type: "UPDATE_SCHEDULE",
        data: {
          schedule: updatedData,
        },
      });
    },
    errorMessages: {
      fileNotExist: "Schedule file does not exist. Please upload a valid one.",
    },
  });

  const scheduleFileInputRef = useRef(null);

  let rosterLastUpdatedAtDisplayText = "";
  let scheduleLastUpdatedAtDisplayText = "";
  if (rosterLastUpdatedAt != null) {
    rosterLastUpdatedAtDisplayText = `Last Updated: ${getFormattedTime(
      new Date(rosterLastUpdatedAt * 1000),
      "en-US",
    )}`;
    if (rosterLastUpdatedBy != null) {
      rosterLastUpdatedAtDisplayText =
        rosterLastUpdatedAtDisplayText + ` (${rosterLastUpdatedBy}@)`;
    }
  }

  if (scheduleLastUpdatedAt != null) {
    scheduleLastUpdatedAtDisplayText = `Last Updated: ${getFormattedTime(
      new Date(scheduleLastUpdatedAt * 1000),
      "en-US",
    )}`;
    if (scheduleLastUpdatedBy != null) {
      scheduleLastUpdatedAtDisplayText =
        scheduleLastUpdatedAtDisplayText + ` (${scheduleLastUpdatedBy}@)`;
    }
  }

  return (
    <div>
      <Box type="fill" spacingInset="400">
        <Row alignmentVertical={"center"} widths={"fill"}>
          <Row alignmentHorizontal={"left"}>
            <Text type="b200">{rosterLastUpdatedAtDisplayText}</Text>
          </Row>
          <Row alignmentHorizontal={"right"}>
            <input
              type="file"
              ref={rosterFileInputRef}
              onChange={handleRosterFileChange}
              accept=".csv"
              style={{ display: "none" }}
            />
            <Button
              type="tertiary"
              size={"small"}
              onClick={() => rosterFileInputRef.current.click()}
              disabled={!isUserAuthorisedForSettingsEdit}
            >
              Upload Roster
            </Button>
            <Button
              type="primary"
              size={"small"}
              onClick={handleRosterDownload}
              disabled={!isUserAuthorisedForSettingsEdit}
            >
              Download Roster
            </Button>
          </Row>
        </Row>
      </Box>
      <div />
      <Box type="fill" backgroundColor="white" spacingInset="200" />
      <Box type="fill" spacingInset="400">
        <Row alignmentVertical={"center"} widths={"fill"}>
          <Row alignmentHorizontal={"left"}>
            <Text type="b200">{scheduleLastUpdatedAtDisplayText}</Text>
          </Row>
          <Row alignmentHorizontal={"right"}>
            <input
              type="file"
              ref={scheduleFileInputRef}
              onChange={handleScheduleFileChange}
              accept=".csv"
              style={{ display: "none" }}
            />
            <Button
              type="tertiary"
              size={"small"}
              onClick={() => scheduleFileInputRef.current.click()}
              disabled={!isUserAuthorisedForSettingsEdit}
            >
              Upload Schedule
            </Button>
            <Button
              type="primary"
              size={"small"}
              onClick={handleScheduleDownload}
              disabled={!isUserAuthorisedForSettingsEdit}
            >
              Download Schedule
            </Button>
          </Row>
        </Row>
      </Box>
      <div />
      {(rosterAlertMessage || scheduleAlertMessage) && (
        <Alert
          type={
            (isValidRosterFile === true && rosterError === false) ||
            (isValidScheduleFile === true && scheduleError === false)
              ? "success"
              : "error"
          }
          size="medium"
        >
          {rosterAlertMessage || scheduleAlertMessage}
        </Alert>
      )}
    </div>
  );
};

export default AmzlRosterManagement;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/AmzlRosterManagement.js